module.exports = __webpack_public_path__ + "static/img/9.4f2e0342.png";